<template>

    <v-modal :title="$t('titles.log_out')">
        <template #body>
            <v-alert :message="error" />
            <p>{{ $t('alerts.logout') }}</p>
        </template>
        <template #footer>
            <v-button size="sm" theme="white" @click.native="cancel">{{ $t('labels.cancel') }}</v-button>
            <v-button size="sm" theme="danger" :loading="loading" @click.native="logout">{{ $t('labels.log_out') }}</v-button>
        </template>
    </v-modal>

</template>

<script>

import AuthApi from '@api/AuthApi';

import Modal from '@cmp/Modal';

export default {

    components: {
        'v-modal': Modal,
    },

    data() {
        return {
            loading: false,
            error: null,
        }
    },

    methods: {

        logout() {
            this.loading = true;
            AuthApi.logout()
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('logout');
                    this.$router.push({ name: 'home' });
                    this.$store.commit('setModal', null);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('setModal', null);
        },

    },

}

</script>
